import * as Yup from 'yup';
import { typeModalMapping } from './modalConfig';

const standardFields = {
  entity: {
    dataType: 'string',
  },
  costCentre: {
    dataType: 'string',
  },
  product: {
    dataType: 'string',
  },
  sorNo: {
    dataType: 'string',
  },
  costType: {
    dataType: 'string',
  },
  sMan: {
    dataType: 'string',
  },
  orderNo: {
    dataType: 'string',
  },
  regionCode: {
    dataType: 'string',
  },
  countryCode: {
    dataType: 'string',
  },
  reference: {
    dataType: 'string',
  },
  expCostAlloc: {
    dataType: 'string',
  },
  financeRemarks: {
    dataType: 'string',
  },
  reimburAmt: {
    dataType: 'number',
    show: false,
  },
  dependent: {
    dataType: 'number',
    show: false,
  },
  expFromDate: {
    dataType: 'string',
    show: false,
  },
  expToDate: {
    dataType: 'string',
    show: false,
  },
  noOfIndividuals: {
    dataType: 'string',
  },
};

export const defaultFieldValues = Object.keys(standardFields).reduce(
  (acc, key) => {
    if (standardFields[key].dataType === 'number') {
      acc[key] = -1; // default for numbers
      return acc;
    }
    acc[key] = '';
    return acc;
  },
  {},
);

export const generateFormSchema = modelType => {
  // grab the modal‐specific config (may be undefined)
  const modalConfig = typeModalMapping[modelType] || {};

  // build up a shape object for Yup.object().shape(...)
  const shape = Object.keys(standardFields).reduce((acc, field) => {
    // 1) start with a base schema according to dataType
    let schema;
    switch (standardFields[field].dataType) {
      case 'string':
        schema = Yup.string();
        break;
      case 'number':
        schema = Yup.number();
        break;
      case 'date':
        schema = Yup.date();
        break;
      default:
        schema = Yup.mixed();
    }

    // 2) if this field has extra validation rules in the modalConfig, apply them
    const cfg = modalConfig[field]?.validation;
    if (cfg) {
      // required
      if (cfg.required?.value) {
        schema = schema.required(cfg.required.message);
      }
      // min / max
      if (cfg.min?.value != null) {
        schema = schema.min(cfg.min.value, cfg.min.message);
      }
      if (cfg.max?.value != null) {
        schema = schema.max(cfg.max.value, cfg.max.message);
      }
      // matches (regex)
      if (cfg.matches?.regex) {
        schema = schema.matches(cfg.matches.regex, cfg.matches.message);
      }
      // custom tests (array)
      if (Array.isArray(cfg.test)) {
        cfg.test.forEach(({ testName, message, func }) => {
          schema = schema.test(testName, message, func);
        });
      }
    }

    acc[field] = schema;
    return acc;
  }, {});

  // finally return the Yup object schema
  return Yup.object().shape(shape);
};
